import { QueryClient } from '@tanstack/react-query';
// Single shared client, also usable outside a QueryClientProvider (e.g. class components).
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
        },
    },
});
export default queryClient;
